import React, { Component } from 'react';
const Approve = ({approve, handleClose}) => (
	<div className="main-reason ml10 mt20">
		{/* <span className="text-lg generate">Generar una tarea a operaciones</span>
		<div className="reasonss">
			<div>
				<input id="reason1" type="checkbox" className="ui-form-control"/>
				<label htmlFor="reason1 text-md" style={{marginBottom: 0}}><span className="text-md">Tarjeta y solicitud no coinciden</span></label>
			</div>
			<div>
				<input id="reason2" type="checkbox" className="ui-form-control"/>
				<label htmlFor="reason2 text-md" style={{marginBottom: 0}}><span className="text-md">Tarjeta y alimentación no coinciden</span></label>
			</div>
		</div> */}
		<span className="text-md mt20 mb20">Por favor, confirma la aprobación de la inspección para que sea comunicada.</span>

	</div>
);
export default Approve;


// WEBPACK FOOTER //
// ./src/components/app/dashboard/inspection/components/resolve/form-approve.js